import React from 'react'
import { Typography } from '@material-ui/core'

import { makeStyles } from '@material-ui/core'
import { content } from '~/themes/colors'

export const useStyles = makeStyles(() => ({
	optionalLabel: {
		color: content.dark,
		textTransform: 'normal',
		fontWeight: 400,
		fontSize: '14px',
		lineHeight: '24px',
	},
}))

const OptionalLabel = () => {
	const classes = useStyles()
	return (
		<Typography variant="body2" className={classes.optionalLabel} data-optional={true}>
			optional
		</Typography>
	)
}

export { OptionalLabel }
